import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApplicationDashboardComponent } from './components/application-dashboard/application-dashboard.component';
import { HostInstitutionComponent } from './components/host-institution/host-institution.component';
import { PocDetailsComponent } from './components/poc-details/poc-details.component';
import { TrackRecordApplicantComponent } from './components/track-record-applicant/track-record-applicant.component';
import { FeasibilitySustainabilityComponent } from './components/feasibility-sustainability/feasibility-sustainability.component';
import { CommitmentsFromApplicantComponent } from './components/commitments-from-applicant/commitments-from-applicant.component';
import { WorkplanComponent } from './components/workplan/workplan.component';
import { BudgetComponent } from './components/budget/budget.component';
import { RevenueGenerationComponent } from './components/revenue-generation/revenue-generation.component';
import { DeclarationComponent } from './components/declaration/declaration.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: ApplicationDashboardComponent,
    data: { title: 'Dashboard', animation: 's1' },
  },
  {
    path: 'host-institution',
    component: HostInstitutionComponent,
    data: { title: 'Host Institution', animation: 's1' },
  },
  {
    path: 'point-of-contact',
    component: PocDetailsComponent,
    data: { title: 'Point Of Contact', animation: 's1' },
  },
  {
    path: 'track-record',
    component: TrackRecordApplicantComponent,
    data: { title: 'Track Record', animation: 's1' },
  },
  {
    path: 'feasibility-sustainability',
    component: FeasibilitySustainabilityComponent,
    data: { title: 'Feasibility Sustainability', animation: 's1' },
  },
  {
    path: 'commitments-applicant',
    component: CommitmentsFromApplicantComponent,
    data: { title: 'Commitments From Applicant', animation: 's1' },
  },
  {
    path: 'workplan',
    component: WorkplanComponent,
    data: { title: 'Workplan', animation: 's1' },
  },
  {
    path: 'revenue-generation',
    component: RevenueGenerationComponent,
    data: { title: 'revenue-generation', animation: 's1' },
  },
  {
    path: 'declaration',
    component: DeclarationComponent,
    data: { title: 'declaration', animation: 's1' },
  },
  {
    path: 'budget',
    component: BudgetComponent,
    data: { title: 'Budget', animation: 's1' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoeRoutingModule {}
